import autoImporter from '@modules/auto-importer';

const requireFilters = require.context(
  './',
  true,
  /^\.\/(?!index\.js$)((\w|-|\.)+\.(js|ts)$|.*\/index\.js$)/
);

export const filters = autoImporter(requireFilters);
